import { isOtherDebtorRetained , getSelectedDebtorList } from "../Functions";

/**
 * @function
 * @param this - Retain debtor and selected debtors
 * @returns - Merge debtor request and refresh params
 */
export function SaveSelectedDebtors(this: any): any {
  const selectedDebtors = getSelectedDebtorList(
    this?.duplicatingDebtors,
    this?.selectedDebtors
  );
  return {
    saveParams: {
      destinationId: this.retainingDebtor?.entRoleId,
      sourceId: this.selectedDebtors,
    },
    caseId: this.caseId,
    debtorId: this.debtorId,
    isOtherDebtorRetained: isOtherDebtorRetained(selectedDebtors),
  };
}
